import NextImage from 'next/image'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'

const TentangAplikasi = () => {
  const router = useRouter()
  const version =
    (Array.isArray(router.query.version)
      ? router.query.version[0]
      : router.query.version) ?? '-'

  return (
    <div className="px-4">
      <div className="flex items-center gap-4 mt-6 mb-6">
        <NextImage
          src="/icon/ruang-gtk/logo.svg"
          alt="Ruang GTK"
          width={145}
          height={80}
        />
        <div>
          <Text variant="heading-md" className="!font-bold">
            Ruang GTK
          </Text>
          <Text variant="body-sm" color="subdued">
            Versi {version}
          </Text>
          <Text variant="body-sm" color="subdued">
            Kemendikdasmen
          </Text>
        </div>
      </div>

      <div className="space-y-4">
        <Text variant="body">
          Ruang GTK terus disempurnakan secara bertahap agar Guru, Kepala
          Sekolah, dan Tenaga Kependidikan dapat mengakses berbagai layanan
          dengan lebih mudah dalam satu aplikasi.
        </Text>
        <Text variant="body">
          Nikmati beranda yang kini lebih sederhana, akses cepat ke Ruang Murid,
          serta berbagai layanan kinerja, pelatihan, dan pembelajaran yang lebih
          terpadu untuk mewujudkan pendidikan bermutu bagi semua.
        </Text>
      </div>
    </div>
  )
}

export default TentangAplikasi
